import { render, staticRenderFns } from "./inquiryInfoCard.vue?vue&type=template&id=6d8da050&scoped=true"
import script from "./inquiryInfoCard.vue?vue&type=script&lang=js"
export * from "./inquiryInfoCard.vue?vue&type=script&lang=js"
import style0 from "./inquiryInfoCard.vue?vue&type=style&index=0&id=6d8da050&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8da050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8da050')) {
      api.createRecord('6d8da050', component.options)
    } else {
      api.reload('6d8da050', component.options)
    }
    module.hot.accept("./inquiryInfoCard.vue?vue&type=template&id=6d8da050&scoped=true", function () {
      api.rerender('6d8da050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/inquiryDetailsPopupChild/inquiryInfoCard.vue"
export default component.exports